/**
 * Directive: contentSubheader
 */
angular.module('acme.common.directive.contentSubheader', [])
.directive('contentSubheader', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/contentSubheader/contentSubheader.tpl.html',
      scope: {},
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.contentSubheader = "Your spankin new contentSubheader!";

      }]

    };

}]);